export const availableServerCacheKey = 'available-servers';
